<template>
  <div
    v-if="assets && assets.length > 0"
    class="library-tag-carousel-component"
  >
    <carousel
      :key="`tag-carousel-${tag.id}`"
      class="library-carousel"
      :item-width="351"
      :show-header="true"
      :tile-count="assets.length"
      :tile-type="'block'"
      :view-all-route="listLink"
      @view-all-clicked="viewAllAnalytics"
    >
      <template v-slot:heading>
        {{ tag.name }}
      </template>
      <block-tile
        v-for="asset in sortedAssets"
        :key="`${asset.assetType}-${asset.id}`"
        :asset="asset"
        :asset-completed="false"
        :asset-in-progress="false"
        :asset-type="asset.assetType"
        :content-source="contentSourceFromAsset(asset)"
        :featured-image="featuredImage(asset)"
        :metadata="metadata(asset)"
        :metadata-icon-name="asset.icon"
        :source="{ type: 'Library' }"
        :state="assetState(asset)"
        :title="assetTitle(asset)"
        @tile-clicked="handleTileClick(asset)"
      />
    </carousel>
  </div>
</template>

<script>
import Carousel from '@/components/carousels/carousel.vue';
import BlockTile from '@/components/ui/blockTile.vue';

import GlobalMixin from '@/mixins/global';

import { titleFromAsset } from '@/utils';

export default {
  name: 'LibraryTagCarousel',
  components: { BlockTile, Carousel },
  mixins: [GlobalMixin],
  props: {
    assets: {
      type: Array,
    },
    parentTag: {
      type: Object,
    },
    sortOrder: {
      type: String,
    },
    states: {
      type: Object,
    },
    tag: {
      type: Object,
    },
  },
  computed: {
    listLink() {
      const query = {
        tag: this.tagsArray,
      };
      if (this.currentQuery?.nav) {
        query.nav = this.currentQuery.nav;
      }
      if (this.$route.query?.tagging) {
        query.tagging = this.$route.query.tagging;
      }
      return {
        name: 'library#list',
        query,
      };
    },
    sortedAssets() {
      return [...this.assets].sort((a, b) => {
        const aLabel = titleFromAsset(a, a.assetType);
        const bLabel = titleFromAsset(b, b.assetType);
        if (this.sortOrder === 'alphabetical') {
          return aLabel?.localeCompare(bLabel);
        } else {
          return bLabel?.localeCompare(aLabel);
        }
      }).slice(0,12);
    },
    tagsArray() {
      let tags = [this.tag.id];
      if (this.parentTag) {
        tags.unshift(this.parentTag.id);
      }
      return tags;
    },
  },
  methods: {
    assetState(asset) {
      if (asset.assetType === 'Attachment') {
        return this.states?.attachments?.find(state => state.attachmentId === asset.id);
      } else {
        return this.states?.topics?.find(state => state.topicId === asset.id);
      }
    },
    assetTitle(asset) {
      return titleFromAsset(asset, asset.assetType);
    },
    contentSourceFromAsset(asset) {
      if (asset.contentSourceId) {
        return this.$store.getters['contentSources/get'][asset.contentSourceId];
      }
    },
    featuredImage(asset) {
      if (asset.displayAttachmentId) {
        return this.$store.getters['attachments/get'][asset.displayAttachmentId];
      }
    },
    handleTileClick(asset) {
      const analyticsParams = {
        assetId: asset.id,
        assetType: asset.assetType,
        assetTitle: this.assetTitle(asset),
        assetLocation: 'Home Library',
        childTag: this.tag.name,
        parentTag: this.parentTag?.name,
      };
      this.$analytics.events.viewedLibraryAsset(analyticsParams);

      const query = {
        tag: this.tagsArray,
      };
      if (this.currentQuery?.nav) {
        query.nav = this.currentQuery.nav;
      }
      if (this.$route.query?.tagging) {
        query.tagging = this.$route.query.tagging;
      }

      this.$router.push({
        ...asset.libraryRoute,
        query,
      });
    },
    metadata(asset) {
      return asset.cardMetadata(this.$store);
    },
    viewAllAnalytics() {
      this.$analytics.events.viewedAllFromLibrary(this.tag.name, this.parentTag.name);
    },
  },
};
</script>

<style lang="scss" scoped>
.library-tag-carousel-component {
  .library-carousel {
    margin-bottom: rem-calc(64);

    @include breakpoint(medium) {
      margin-bottom: rem-calc(32);
    }
  }
}
</style>
